import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import { useClasses } from "../hooks";

const MessageContainer = Styled.div`
  padding: 20px;
  color: white;
  border-radius: 10px;

  &.danger {
    background: #ba341e;
  }

  &.success {
    background: var(--neko-green);
  }

  a {
    color: white;
    font-weight: bold;
  }
`;

const StyledNekoMessage = (props) => {
  const { variant, children, ...rest } = props;
  const className = useClasses(
    'neko-message',
    {'danger': variant === 'danger'},
    {'success': variant === 'success'}
  );

  return <MessageContainer className={className} {...rest}>
    { children }
  </MessageContainer>
}

const NekoMessage = (props) => {
  return <StyledNekoMessage {...props} />;
};

NekoMessage.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.node,
};

NekoMessage.defaultProps = {
  variant: undefined,
  children: undefined,
};

export { NekoMessage };